import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalCreateBusinessLocationForm = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;
  const [companyID, setCompanyID] = useState("");
  const [type, setType] = useState("");
  const [companyBusinessLocationName, setCompanyBusinessLocationName] = useState("");
  const [companyBusinessLocationAddress, setCompanyBusinessLocationAddress] = useState("");
  const [companies, setCompanies] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getRegisteredCompanyOnUploadForm');
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setCompanies(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the companies!", error);
      });
      setIsFormValid(companyID && type && companyBusinessLocationName && companyBusinessLocationAddress);
    }, [companyID, type, companyBusinessLocationName, companyBusinessLocationAddress]);


  const handleInputChange = (e) => {
    const { id, value } = e.target;
    switch (id) {
      case "companyID":
        setCompanyID(value);
        break;
        case "type":
          setType(value);
          break;
      case "companyBusinessLocationName":
        setCompanyBusinessLocationName(value);
        break;
      case "companyBusinessLocationAddress":
        setCompanyBusinessLocationAddress(value);
        break;        
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("companyID", companyID);
    formData.append("businessType", type);
    formData.append("companyBusinessLocationName", companyBusinessLocationName);
    formData.append("companyBusinessLocationAddress", companyBusinessLocationAddress);
    formData.append("apiType", 'registerCompanyBusinessLocation');

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        const data = response.data;
        setCompanyID("");
        setType("");
        setCompanyBusinessLocationName("");
        setCompanyBusinessLocationAddress("");
        if (data === 'Upload Completed Successfully' || data === '') {
          alert('Data Upload Completed Successfully');
        } else {
          alert(data);
        }
      })
      .catch(error => {
        alert('Error: Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
      });
  };

  return (
    <>
      <Header />
      <hr />
      <div className="mt-5" id="modalCreateBusinessLocationForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="heading lead">Register Company Business Location</p>
             
            </div>
            <div className="modal-body">
              <form id="fileUploadFormRegisterCompanyBusinessLocation" onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">
                  <div className="col-lg-12 col-md-12 mb-4 text-left">
                    <label htmlFor="companyID">Company</label>
                    <select className="custom-select d-block w-100" id="companyID" name="companyID" value={companyID} onChange={handleInputChange} required>
                      <option value="">Choose..</option>
                      {companies.map(company => (
                        <option key={company.companyID} value={company.companyID}>{company.companyName}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12 col-md-12 mb-4 text-left">
                    <label htmlFor="type">Type</label>
                    <select className="custom-select d-block w-100" id="type" name="type" value={type} onChange={handleInputChange} required>
                      <option value="">Choose..</option>
                        <option >Plots</option>
                        <option >Houses</option>
                    </select>
                  </div>
                  <div className="col-lg-12 col-md-12 mb-4 text-left">
                    <div className="md-form md-outline">
                      <input type="text" id="companyBusinessLocationName" name="companyBusinessLocationName" className="form-control" value={companyBusinessLocationName} onChange={handleInputChange} required />
                      <label htmlFor="companyBusinessLocationName">Business Location Name</label>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 mb-4 text-left">
                    <div className="md-form md-outline">
                      <textarea id="companyBusinessLocationAddress" name="companyBusinessLocationAddress" className="form-control" value={companyBusinessLocationAddress} onChange={handleInputChange} required></textarea>
                      <label htmlFor="companyBusinessLocationAddress">Address</label>
                    </div>
                  </div>
                  <input type="hidden" id="apiType" name="apiType" value="registerCompanyBusinessLocation" />
                  <div className="text-center mt-0">
                    <button type="submit" className="btn btn-success" id="registerCompanyBusinessLocation" disabled={!isFormValid}>Register <i className="fas fa-coins ml-1"></i></button>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalCreateBusinessLocationForm;
